export interface AdBanner {
  id: string;
  sponsor: string;
  tagline: string;
  description: string;
  image_url: string;
  cta_label: string;
  category: string;
}

export const adBanners: AdBanner[] = [
  {
    id: 'ad-1',
    sponsor: 'TogoPay',
    tagline: 'Envoyez et recevez de l&apos;argent en un clic',
    description: 'Le paiement mobile simple, rapide et sécurisé pour toute l&apos;Afrique.',
    image_url:
      'https://readdy.ai/api/search-image?query=Modern%20African%20fintech%20promotional%20banner%20with%20sleek%20smartphone%20and%20glowing%20payment%20interface%20clean%20minimal%20design%20warm%20amber%20and%20orange%20accents%20wide%20banner%20format%20professional%20advertising%20artwork%20high%20detail&width=1600&height=420&seq=ad-1&orientation=landscape',
    cta_label: 'Découvrir',
    category: 'Fintech',
  },
  {
    id: 'ad-2',
    sponsor: 'Maison Wax Royale',
    tagline: 'La nouvelle collection Wax est arrivée',
    description: 'Des tenues sur mesure qui subliment votre élégance africaine.',
    image_url:
      'https://readdy.ai/api/search-image?query=African%20fashion%20brand%20advertising%20banner%20featuring%20elegant%20wax%20print%20clothing%20on%20a%20model%20vibrant%20patterns%20warm%20golden%20studio%20lighting%20wide%20banner%20format%20professional%20advertising%20rich%20warm%20tones%20high%20detail&width=1600&height=420&seq=ad-2&orientation=landscape',
    cta_label: 'Voir la collection',
    category: 'Mode',
  },
  {
    id: 'ad-3',
    sponsor: 'Banque Atlantique Togo',
    tagline: 'Financez vos projets dès aujourd&apos;hui',
    description: 'Des solutions de crédit adaptées à vos ambitions.',
    image_url:
      'https://readdy.ai/api/search-image?query=African%20bank%20financial%20services%20promotional%20banner%20with%20modern%20building%20and%20happy%20customers%20clean%20professional%20design%20warm%20tones%20wide%20banner%20advertising%20artwork%20high%20detail&width=1600&height=420&seq=ad-3&orientation=landscape',
    cta_label: 'En savoir plus',
    category: 'Finance',
  },
  {
    id: 'ad-4',
    sponsor: 'Délices du Golfe',
    tagline: 'Vos plats préférés livrés en 30 min',
    description: 'La cuisine locale, chaude et savoureuse, directement chez vous.',
    image_url:
      'https://readdy.ai/api/search-image?query=African%20food%20delivery%20service%20advertising%20banner%20with%20delicious%20traditional%20dishes%20fresh%20ingredients%20warm%20appetizing%20lighting%20wide%20banner%20format%20professional%20advertising%20rich%20warm%20colors%20high%20detail&width=1600&height=420&seq=ad-4&orientation=landscape',
    cta_label: 'Commander',
    category: 'Restauration',
  },
  {
    id: 'ad-5',
    sponsor: 'Togocom',
    tagline: 'Restez connectés, où que vous soyez',
    description: 'La 4G la plus rapide du Togo, des forfaits pour tous.',
    image_url:
      'https://readdy.ai/api/search-image?query=African%20telecom%20company%20advertising%20banner%20with%20connected%20people%20using%20smartphones%20vibrant%20modern%20design%20warm%20amber%20gradient%20background%20wide%20banner%20format%20professional%20advertising%20artwork%20high%20detail&width=1600&height=420&seq=ad-5&orientation=landscape',
    cta_label: 'Voir les offres',
    category: 'Télécom',
  },
  {
    id: 'ad-6',
    sponsor: 'Moov Africa Togo',
    tagline: 'La connexion qui vous ressemble',
    description: 'Internet mobile ultra-rapide et appels illimités pour tout le Togo.',
    image_url:
      'https://readdy.ai/api/search-image?query=African%20telecom%20company%20advertising%20banner%20with%20a%20happy%20family%20using%20smartphones%20and%20high%20speed%20internet%20icons%20modern%20vibrant%20design%20warm%20amber%20and%20orange%20gradient%20background%20wide%20banner%20format%20professional%20advertising%20artwork%20high%20detail&width=1600&height=420&seq=ad-6&orientation=landscape',
    cta_label: 'Découvrir',
    category: 'Télécom',
  },
  {
    id: 'ad-7',
    sponsor: 'Ecobank',
    tagline: 'Votre banque panafricaine, partout avec vous',
    description: 'Des solutions bancaires simples et accessibles pour tous vos projets.',
    image_url:
      'https://readdy.ai/api/search-image?query=Modern%20pan%20African%20bank%20advertising%20banner%20with%20a%20professional%20smiling%20customer%20and%20a%20sleek%20banking%20app%20interface%20clean%20design%20warm%20amber%20accents%20wide%20banner%20format%20professional%20advertising%20artwork%20high%20detail&width=1600&height=420&seq=ad-7&orientation=landscape',
    cta_label: 'Ouvrir un compte',
    category: 'Finance',
  },
  {
    id: 'ad-8',
    sponsor: 'Lomé, Togo',
    tagline: 'Découvrez la perle de l&apos;Afrique de l&apos;Ouest',
    description: 'Marchés colorés, culture vibrante et hospitalité légendaire au cœur du Golfe de Guinée.',
    image_url:
      'https://readdy.ai/api/search-image?query=Vibrant%20colorful%20open%20air%20street%20market%20in%20Lome%20Togo%20West%20Africa%20with%20traditional%20wax%20fabric%20stalls%20fresh%20produce%20and%20baskets%20of%20spices%20local%20vendors%20and%20joyful%20shoppers%20in%20warm%20golden%20afternoon%20sunlight%20lively%20authentic%20atmosphere%20travel%20photography%20wide%20banner%20format%20rich%20warm%20tones%20high%20detail&width=1600&height=420&seq=ad-lome-culture&orientation=landscape',
    cta_label: 'Explorer Lomé',
    category: 'Culture',
  },
  {
    id: 'ad-9',
    sponsor: 'WorldApeiron',
    tagline: 'Votre écosystème digital tout-en-un',
    description: 'Entreprises, talents, médias, boutiques et IA réunis sur une seule plateforme pensée pour l&apos;Afrique.',
    image_url:
      'https://readdy.ai/api/search-image?query=Modern%20African%20digital%20ecosystem%20platform%20promotional%20banner%20showcasing%20an%20interconnected%20network%20of%20apps%20services%20and%20digital%20tools%20with%20glowing%20nodes%20flowing%20data%20streams%20and%20abstract%20geometric%20shapes%20in%20warm%20amber%20orange%20and%20gold%20gradient%20tones%20clean%20futuristic%20interface%20design%20wide%20banner%20format%20professional%20advertising%20artwork%20high%20detail&width=1600&height=420&seq=ad-worldapeiron&orientation=landscape',
    cta_label: 'Explorer la plateforme',
    category: 'Plateforme',
  },
];